import Component from 'core/Component';
import { deepMerge } from 'toolbox/deepMerge';
import { cookie } from 'toolbox/cookie';
import { ajax } from 'toolbox/ajax';
import { stringify } from 'toolbox/queryString';

/**
 * Component manages cookie about viewed products, categories.
 * @class
 * @extends Component
 */
export default class PersonalizationTracking extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            data: null, // tracking data
            cookieID: null, // tracking cookie id
        }, options));
    }

    /**
     * After init
     * Run any script after the component is fully initialized
     */
    afterInit() {
        this.track(this.options.data || {});
    }

    /**
     * Track data
     * @param {Object} data tracking data
     */
    track(data) {
        const { context, item } = data;

        if (!context || !item) {
            return;
        }

        let json = this.getTrackingData();

        json[context] = json[context] || { count: 0, items: [] };

        if (json[context].items.indexOf(item) === -1) {
            // count how many items were tracked before server push
            json[context].count += 1;
        } else {
            // remove existing item, to be able to move it to the end of array
            json[context].items = json[context].items.filter(value => value !== item);
        }

        // append last visited item
        json[context].items.push(item);

        if (json[context].items.length > this.options.limit) {
            json[context].items = json[context].items.slice(-this.options.limit);
        }

        this.setTrackingData(json);

        // if threshold reached, tracking data should be updated on server side
        if (json[context].count >= this.options.threshold) {
            ajax(this.options.url.track, {
                method: 'POST',
                body: stringify({ context }),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            }).then(() => {
                // reset count of tracked items before sync
                json = this.getTrackingData();
                json[context].count = 0;
                this.setTrackingData(json);
            }).catch(() => {});
        }
    }

    /**
     * Returns saved tracking data
     * @returns {Object} tracking data
     */
    getTrackingData() {
        let json = {};

        try {
            json = JSON.parse(decodeURIComponent(cookie.getCookie(this.options.cookieID)));
        } catch (e) {
            json = {};
        }

        return json;
    }

    /**
     * Set tracking data
     * @param {Object} data tracking data
     */
    setTrackingData(data) {
        cookie.setCookie(this.options.cookieID, encodeURIComponent(JSON.stringify(data)));
    }
}
